export const parameterize = (str, fields) =>
  str.replace(/{{([^}]*)}}/g, (_, k) => fields[k]);
